<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.asset_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="assetService.loading()"
    [iconButton]="true"
    (click)="assetService.addAsset()"
    sbTooltip="{{ 'lang.globals.assets.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="assetService.requestDebouncedAssets()"
    [disabled]="assetService.loading()"
    [loading]="assetService.loading()">
  </button>

</ng-container>

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="assetService.showSideBar = $event" [show]="assetService.showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="assetService.selectedAsset?.id ? 1000 : 500">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="assetService.selectedAsset" [innerHTML]="assetService.selectedAsset?.name | truncate : 30"></h4>
    <h4 *ngIf="!assetService.selectedAsset">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-asset-edit></sb-page-asset-edit>
</ng-template>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.inRepository'|translate : {name: assetService?.selectedRepository?.name} }}"
  [itemsData]="assetService.assets"
  (paginationChange)="assetService.requestDebouncedAssets($event)"
  [loading]="assetService.loading()"
  [itemName]="'assets'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="assetService.filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        Tags
      </th>
      <th>
        {{ 'lang.globals.created' | translate }}
      </th>
      <th>
        {{ 'lang.globals.category' | translate }}
      </th>
      <th>
        {{ 'lang.globals.resolution' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-asset>

    <tr>
      <td>
        {{ asset?.id }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [still]="true" [hoverPreview]="true"
                                    [image]="asset?.preview?.thumbnailLink?asset?.preview?.thumbnailLink: asset?.preview?.link">
          <span firstLine class="cursor-pointer" (click)="assetService.editAsset(asset)" [innerHtml]="asset?.name|truncate:30"></span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <div *ngIf="asset.tags?.length < 4">
          <div *ngFor="let tag of asset?.tags">
            {{ tag }}
          </div>
        </div>
        <div *ngIf="asset.tags?.length > 4">
          <div class="d-flex">
      <span [ngbPopover]="popContent" autoClose="outside"
            class="tag grey-bg white cursor-pointer" container="body" popoverClass="tag-container">
    <sb-icon class="mr-1" icon="tags"></sb-icon>
        {{ asset.tags ? asset.tags.length : null }}
  </span>
          </div>
          <ng-template #popContent>
            <div class="d-flex">
      <span *ngFor="let tag of asset.tags"
            class="tag mr-1 cursor-pointer tag-input">
        <sb-icon (click)="assetService.removeTag(tag)" class="mr-1"
                 icon="cancel" style="font-size: .6rem;"></sb-icon>
        <span [innerHTML]="tag | truncate: 5"></span>
    </span>
            </div>
          </ng-template>
        </div>
      </td>
      <td>
        <sb-comp-display-created [data]="asset"></sb-comp-display-created>
      </td>
      <td>
        &nbsp;{{ asset?.category?.name }}
      </td>
      <td>
        <span [ngbTooltip]="filesResolution" container="body" placement="left">{{ asset?.assetFiles?.length }}</span>
        <ng-template #filesResolution>
          <div *ngFor="let assetFile of asset?.assetFiles">
            {{ assetFile?.resolution?.width }}x{{ assetFile?.resolution?.height }}
          </div>
        </ng-template>
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="asset.sbButtons ?? []"
            (selectedAction)="assetService.resolveSplitButtonActionAssets(asset, $event)"
          ></sb-split-button>
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectAsset(asset)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!--

  <ng-template #card let-asset>
    <div>
      <sb-card>
        <div card-img classes="position-relative">

          <sb-preview-tooltip [interval]="5000" [hoverPreview]="false" [showFullOnClick]="true"
                              [customWidth]="100+'%'" [customHeight]="300+'px'"
                              [previews]="campaign?.preview"></sb-preview-tooltip>

          <div style="position: absolute;top: 15px;right: 15px">
            <button class="btn btn-danger" (click)="assetService.deleteAsset(asset)">
              <sb-icon icon="trash"></sb-icon>
            </button>
          </div>
        </div>
        <div card-footer>
          <div class="d-flex justify-content-between align-items-center">
            <div>
               todo tags
            </div>
            <div class="d-flex">
              <sb-icon class="mr-1" icon="category"></sb-icon>
              {{asset?.category ? asset?.category?.name : '-'}}
            </div>
            <div class="d-flex ">
              <sb-icon class="mr-1" icon="resolution"></sb-icon>
              {{asset?.assetFiles ? asset?.assetFiles?.length : '-'}}
            </div>
          </div>
        </div>
      </sb-card>
      <h3>
        {{asset.name}}
      </h3>
    </div>
  </ng-template>
-->
</sb-table-wrapper-new>
